import { handleActions } from "redux-actions";

import { removeById, updateById } from "utils";

const channelReducer = handleActions(
  {
    PORTFOLIO_CHANNELS_GET: {
      FULFILLED: (state, action) => ({
        portfolioChannels: action.payload.channels,
      }),
    },
    DEAL_CHANNELS_GET: {
      FULFILLED: (state, action) => ({
        channels: action.payload.channels,
      }),
    },
    DEAL_CHANNEL_CREATE: {
      FULFILLED: (state, action) => ({
        channels: [...state.channels, action.payload.channel],
        portfolioChannels: [...state.portfolioChannels, action.payload.channel],
      }),
    },
    DEAL_CHANNEL_DELETE: {
      FULFILLED: (state, action) => ({
        channels: removeById(state.channels, action.meta.channelID),
        portfolioChannels: removeById(state.portfolioChannels, action.meta.channelID),
      }),
    },
    DEAL_CHANNEL_SAVE: {
      FULFILLED: (state, action) => ({
        channels: updateById(state.channels, action.payload.channel),
        portfolioChannels: updateById(state.portfolioChannels, action.payload.channel),
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default channelReducer;
